import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { addRecentAdminCompany } from '../stores/org-store';

export function useEnterCompany() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useCallback(
    (company: { pid: string; name: string; slug: string }) => {
      addRecentAdminCompany(company);
      void queryClient.invalidateQueries();
      void navigate({ to: '/$orgPid/dashboard', params: { orgPid: company.pid } });
    },
    [queryClient, navigate]
  );
}
